
export function Footer() {
  return (
    <footer className="bg-gray-900 py-10 sm:py-12 lg:py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-10">
          <h3 className="text-xl sm:text-2xl font-bold text-white mb-4 sm:mb-6">Mis Redes Sociales</h3>
          <div className="flex justify-center gap-4 sm:gap-6">
            <a
              href="https://www.tiktok.com/@esaullorenzo.a"
              target="_blank"
              rel="noopener noreferrer"
              className="w-11 h-11 sm:w-12 sm:h-12 lg:w-14 lg:h-14 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-800 rounded-full hover:from-pink-500 hover:to-rose-500 transition-all duration-300 hover:scale-110 cursor-pointer"
              aria-label="TikTok"
            >
              <i className="ri-tiktok-fill text-white text-xl sm:text-2xl"></i>
            </a>
            <a
              href="https://www.instagram.com/esaullorenzo/?hl=es"
              target="_blank"
              rel="noopener noreferrer"
              className="w-11 h-11 sm:w-12 sm:h-12 lg:w-14 lg:h-14 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-800 rounded-full hover:from-purple-500 hover:via-pink-500 hover:to-orange-400 transition-all duration-300 hover:scale-110 cursor-pointer"
              aria-label="Instagram"
            >
              <i className="ri-instagram-fill text-white text-xl sm:text-2xl"></i>
            </a>
            <a
              href="https://www.youtube.com/@ESAULLORENZO"
              target="_blank"
              rel="noopener noreferrer"
              className="w-11 h-11 sm:w-12 sm:h-12 lg:w-14 lg:h-14 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-800 rounded-full hover:from-red-500 hover:to-red-600 transition-all duration-300 hover:scale-110 cursor-pointer"
              aria-label="YouTube"
            >
              <i className="ri-youtube-fill text-white text-xl sm:text-2xl"></i>
            </a>
          </div>
        </div>
        
        <div className="border-t border-gray-700 pt-6 sm:pt-8">
          <p className="text-center text-gray-400 text-xs sm:text-sm">
            © {new Date().getFullYear()} Método ScaleUp. Todos los derechos reservados
          </p>
        </div>
      </div>
    </footer>
  );
}
